import React from "react";
import {
  HeaderContainer,
  Logo,
  HeaderLogoContainer,
  HeaderNavbarContainer,
  HeaderImageContainer,
  HeaderNavigationContainer,
  HeaderMainTitleStyle,
  SeparatorLine,
  HeaderSubTitleStyle,
} from "./Header.style";
import { NavBar } from "../../components";

interface Props {
  logo: string;
  color: string;
  title: string;
  subtitle: string;
  productLogo?: string;
  shouldDisplayBanner?: boolean;
  header: string;
}

const HeaderComponent: React.FC<Props> = (props) => {
  return (
    <HeaderContainer>
      <HeaderNavigationContainer>
        <HeaderLogoContainer className="Logo">
          <Logo logo={props.logo} />
        </HeaderLogoContainer>
        <HeaderNavbarContainer>
          <NavBar />
        </HeaderNavbarContainer>
      </HeaderNavigationContainer>
      {props.shouldDisplayBanner && (
        <HeaderImageContainer bg={props.header}>
          <HeaderMainTitleStyle>{props.title}</HeaderMainTitleStyle>
          <SeparatorLine />
          <HeaderSubTitleStyle>{props.subtitle}</HeaderSubTitleStyle>
        </HeaderImageContainer>
      )}
    </HeaderContainer>
  );
};

export default HeaderComponent;
